/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfGuid } from "../models/AjaxResponseOfGuid";
import type { AjaxResponseOfListOfVehicleExpensesDto } from "../models/AjaxResponseOfListOfVehicleExpensesDto";
import type { AjaxResponseOfVehicleExpensesDto } from "../models/AjaxResponseOfVehicleExpensesDto";
import type { VehicleExpenseCreateDto } from "../models/VehicleExpenseCreateDto";
import type { VehicleExpenseUpdateDto } from "../models/VehicleExpenseUpdateDto";

import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";

export class VehicleExpensesAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @returns AjaxResponseOfListOfVehicleExpensesDto
   * @throws ApiError
   */
  public getAll({
    vehicleId,
  }: {
    vehicleId: string;
  }): CancelablePromise<AjaxResponseOfListOfVehicleExpensesDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-expenses/{vehicleId}/todos",
      path: {
        vehicleId: vehicleId,
      },
    });
  }

  /**
   * @returns AjaxResponseOfVehicleExpensesDto
   * @throws ApiError
   */
  public getById({
    id,
  }: {
    id: string;
  }): CancelablePromise<AjaxResponseOfVehicleExpensesDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/vehicle-expenses/{id}",
      path: {
        id: id,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({ id }: { id: string }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/vehicle-expenses/{id}",
      path: {
        id: id,
      },
    });
  }

  /**
   * @returns AjaxResponseOfGuid
   * @throws ApiError
   */
  public create({
    requestBody,
  }: {
    requestBody?: VehicleExpenseCreateDto;
  }): CancelablePromise<AjaxResponseOfGuid> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/vehicle-expenses",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public update({
    requestBody,
  }: {
    requestBody?: VehicleExpenseUpdateDto;
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "PUT",
      url: "/api/front-end/v1/vehicle-expenses",
      body: requestBody,
      mediaType: "application/json-patch+json",
    });
  }
}
